import home from './home';
import lightInitiativeItem from './components/light_initiative_item';
import splitPill from './components/split_pill';

export default angular
  .module('App.home', [])
  .component('homePage', home)
  .component('lightInitiativeItem', lightInitiativeItem)
  .component('splitPill', splitPill).name;
